/**
 * Web no-op counterpart of ModalKeyboardProvider.
 *
 * There is no native keypad to measure, and react-native-keyboard-controller is
 * aliased to `false` in webpack.config.js — importing it here would resolve to
 * an empty module and `KeyboardProvider` would be undefined.
 */
import React from 'react';

export const ModalKeyboardProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return <>{children}</>;
};
